import { useState } from "react";
import VerificarAccesoForm from "./verificarAccesoForm/VerificarAccesoForm";
import { useToast } from "../../Hooks/UseToast";
import { fetchFunction } from "./FetchFunction";
import { Box, Container } from "@mui/material";
import CreateCard from "./createCard/CreateCard";
import SkeletonCards from "./skeletonCards/SkeletonCards";
import AccesoPlantaCard from "./pantallasDeEstado/AccesoPlantaCard";
import Navbar from "../Navbar";

const Index = () => {
  const [chofer, setChofer] = useState(null);
  const [camion, setCamion] = useState(null);
  const [tanque, setTanque] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [dniDelChofer, setDniDelChofer] = useState("");
  const [patenteDelCamion, setPatenteDelCamion] = useState("");
  const [patenteDelTanque, setPatenteDelTanque] = useState("");
  const [permitAccesoDelCamionAPlanta, setPermitAccesoDelCamionAPlanta] =
    useState(null);
  const [documentosQueFaltan, setDocumentosQueFaltan] = useState(null);

  const { Toast, showToast } = useToast();

  const handleSubmit = async (dni, patenteCamion, patenteTanque) => {
    setIsLoading(true);
    try {
      const data = await fetchFunction(dni, patenteCamion, patenteTanque);
      const chofer = data?.data.chofer;
      const camion = data?.data.camion;
      const tanque = data?.data.tanque;

      const todosLosDocumentos = [
        ...chofer.documentos,
        ...tanque.documentos,
        ...camion.documentos,
      ];

      const datosFaltantes = todosLosDocumentos.filter(
        (d) => d.estado === "Faltan documentos"
      );

      const missing = [];
      if (!chofer) missing.push("chofer");
      if (!tanque) missing.push("tanque");
      if (!camion) missing.push("camion");
      if (missing.length) {
        showToast(
          `No se encontraron los siguientes datos: ${missing.join(", ")}`,
          "error"
        );
        setCamion(null);
        setTanque(null);
        setChofer(null);
        setDocumentosQueFaltan(null);
        setIsLoading(false);
        return;
      }

      setDocumentosQueFaltan(datosFaltantes);
      setPermitAccesoDelCamionAPlanta(data.data.valido); //Esto es lo mas importante del programa, donde te dice si el camion puede acceder (Solo si tiene todos los documentos al dia, tanto de chofer, camion como tanque) y es un estado booleano
      setChofer(chofer);
      setCamion(camion);
      setTanque(tanque);
      setIsLoading(false);
    } catch (err) {
      showToast(err.message, "error");
      setCamion(null);
      setTanque(null);
      setChofer(null);
      setDocumentosQueFaltan(null);
      setIsLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <VerificarAccesoForm
          dniDelChofer={dniDelChofer}
          setDniDelChofer={setDniDelChofer}
          patenteDelCamion={patenteDelCamion}
          setPatenteDelCamion={setPatenteDelCamion}
          patenteDelTanque={patenteDelTanque}
          setPatenteDelTanque={setPatenteDelTanque}
          handleSubmit={() =>
            handleSubmit(dniDelChofer, patenteDelCamion, patenteDelTanque)
          }
        />

        {/* Se fija si esta cargando, mientras lo hace muestra el esqueleto, despues verifica si las 3 entidades llegaron con datos para ver si muestra data o no (La idea es hacer una pantalla para cuando no haya data)*/}
        {isLoading ? (
          <Box sx={{ pt: 0.5 }}>
            <SkeletonCards count={3} />
          </Box>
        ) : chofer !== null && camion !== null && tanque !== null ? (
          <>
            {permitAccesoDelCamionAPlanta !== null && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                <AccesoPlantaCard
                  permitAccesoDelCamionAPlanta={permitAccesoDelCamionAPlanta}
                  documentosFaltantes={documentosQueFaltan}
                />
              </Box>
            )}
            <CreateCard key={"chofer"} nombre={"Chofer"} entidad={chofer} />
            <CreateCard key={"camion"} nombre={"Camion"} entidad={camion} />
            <CreateCard key={"tanque"} nombre={"Tanque"} entidad={tanque} />
            <Box sx={{ mb: 6 }}></Box>
          </>
        ) : null}
      </Container>
      {Toast}
    </>
  );
};

export default Index;
